module.exports = "https://s81616.cdn.ngenix.net/microcredits-frontend/_next/static/images/lightFirstStep-94b8a76d90f74767107a701478e5d849.png";